module.exports = __webpack_public_path__ + "assets/img/home_s_i2.d691d252.png";